module.exports = __webpack_public_path__ + "media/images/countrysquared/cl-a16bd71ff5cfee5c709da46b76c4b2e7.svg";